export default "__VITE_ASSET__ZDpCt6KX__"